/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCubeEmpty: {
  name: 'cube-empty';
  data: string;
} = {
  name: 'cube-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.105 2.33a2 2 0 0 1 1.79 0l7 3.5c.11.054.213.119.309.191a.998.998 0 0 1 .763 1.234c.022.119.033.24.033.363v8.764a2 2 0 0 1-1.106 1.789l-7 3.5c-.088.044-.179.081-.271.112a.996.996 0 0 1-1.246 0 2.007 2.007 0 0 1-.272-.112l-7-3.5A2 2 0 0 1 3 16.382V7.618a2 2 0 0 1 .033-.363.998.998 0 0 1 .763-1.234c.096-.072.2-.137.31-.192l7-3.5ZM13 19.381l6-3V8.618l-6 3v7.764Zm-2-7.764v7.764l-6-3V8.618l6 3Zm1-7.5L17.764 7 12 9.882 6.236 7 12 4.118Z" fill="currentColor"/></svg>`,
};
